import {
  __,
  el,
  TextControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editSearchCountry = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(TextControl,
    {
      label: __('Filtrer la recherche à un pays'),
      className: "input-box",
      value: attributes.searchCountry,
      onChange: (value) => {
        setAttributes({ searchCountry: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.add('input-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('input-focused');
        }
      }
    }
  )
}

export { editSearchCountry }
